import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortBy',
    pure: false
})
export class SortByFilterPipe implements PipeTransform {

  transform(items: Array<any>, args?: any): any {
    
    if (args['property'].trim() === '') {
      return items;
    } else {
      if (args.property === 'engines' || args.property === 'series') {
        items.map(item => {
          let nameArray = [];
          for (let i = 0; i < item[args.property].length; i++) {
            nameArray.push( (args.property === 'engines') ? item.engines[i].engineName : item.series[i].seriesName);
          }
          if (args.property === 'engines') {
            return item['engineName'] = nameArray;
          } else {
            return item['seriesName'] = nameArray;
          }
        });
      }
      if (args.property === 'brand'){
        items.map(item => {
          return item['brand'] = item.make.makeName;
        });
      }
      return items?.sort(function (a, b) {
        if (a[args.property] < b[args.property]) {
          return -1 * args.direction;
        } else if (a[args.property] > b[args.property]) {
          return 1 * args.direction;
        } else {
          return 0;
        }
      });
    }
  }
}
